import { calculateBackgroundPositionX, initSlider } from '../international-leasing-calculator/slider.js'
import { updateCalculation, wasCalculationPerformed } from './calculation.js'
import {
  findNearestMonth,
  initPlaceholderDropdown,
  showAndScrollToForm
} from '../international-leasing-calculator/helper.js'
import { getCurrencyFormatNumbersOnly } from '../utils/utils.js'
import NumberParser from './NumberParser.js'
import leasingData from './leasing-data.js'
//import testData from "./test-data/leasing-calculator_only_one_product.json";
//import testData from "./test-data/leasing-calculator_only_one_product_and_one_asset.json";
//import testData from "./test-data/leasing-calculator_more_products.json";

function init () {
  const leasingCalc = document.getElementById('leasing-calc')
  if (!leasingCalc) return

  const TEST = false

  const productSelect = leasingCalc.querySelector('#product-select')
  const assetSelect = leasingCalc.querySelector('#asset-select')
  const leasingValueSlider = leasingCalc.querySelector('#leasing-value-slider')
  const leasingRuntimeSlider = leasingCalc.querySelector('#leasing-runtime-slider')
  const leasingMoneyInput = leasingCalc.querySelector('#leasing-money-input')
  const leasingRuntimeDropdown = leasingCalc.querySelector('#leasing-runtime-dropdown')
  const leasingModalContainer = leasingCalc.querySelector('#leasing-modal-container')
  const leasingModalButton = leasingCalc.querySelector('#leasing-modal-button')
  const leasingCalculationContainer = leasingCalc.querySelector('#leasing-calculation-container')
  const leasingResultContainer = leasingCalc.querySelector('#leasing-result-container')
  const leasingResult = leasingCalc.querySelector('#leasing-result')
  const leasingCurrencyInMoneyInput = leasingCalc.querySelector('#leasing-currency')
  const leasingResultUnit = leasingCalc.querySelector('#leasing-result-unit')
  const leasingSubmit = leasingCalc.querySelector('#leasing-submit')
  const leasingSubmitText = leasingCalc.querySelector('#leasing-submit-text')
  const leasingCalcForm = leasingCalc.querySelector('#leasing-calculator-form')

  const FALLBACK_LOCALE = 'de-DE'
  const FALLBACK_CURRENCY = 'EUR'
  const FALLBACK_MIN_VALUE = 500
  const FALLBACK_MAX_VALUE = 200000

  let minValueleasingValueSlider
  let maxValueleasingValueSlider

  leasingValueSlider.disabled = true
  leasingMoneyInput.disabled = true
  leasingRuntimeSlider.disabled = true
  leasingRuntimeDropdown.disabled = true
  leasingSubmit.disabled = true

  leasingCalcForm.addEventListener('submit', (e) => e.preventDefault())

  getJson()
  populateDropdowns()
  initializeLeasingValueSliderFromJson(leasingValueSlider)

  if (leasingData.getShowModalFlag()) {
    leasingSubmitText.style.display = 'block'
    leasingModalContainer.style.display = 'block'
  }

  if (leasingData.getShowRate()) {
    leasingResultContainer.style.display = 'block'
  }

  if (!leasingData.getShowModalFlag() && !leasingData.getShowRate()) {
    leasingCalculationContainer.style.display = 'none'
  }

  leasingValueSlider.addEventListener('input', function () {
    updateLeasingMoneyInput(leasingValueSlider.value)
  })

  assetSelect.addEventListener('change', () => {
    populateRuntimeSliderFromAssetSelection()
    handleInputChange()
  })

  leasingModalButton.addEventListener('click', function () {
    $('#leasing-calc #leasing-modal').modal('show')
  })

  leasingSubmit.addEventListener('click', function () {
    showAndScrollToForm(leasingCalc, leasingData.getLabels())
    updateForm()
  })

  function handleInputChange () {
    updateCalculation(
      leasingData,
      leasingRuntimeDropdown,
      leasingMoneyInput,
      leasingResult
    )

    if (wasCalculationPerformed()) {
      leasingValueSlider.disabled = false
      leasingMoneyInput.disabled = false
      leasingRuntimeSlider.disabled = false
      leasingRuntimeDropdown.disabled = false
      leasingSubmit.disabled = false
      leasingResultUnit.classList.remove('invisible')
    }
  }

  // -------------------------
  // Read JSON from hidden container and put it into leasingData
  // -------------------------
  function getJson () {
    if (TEST) {
      // TESTMODUS: use imported json
      leasingData.setData(testData) // ← testData kommt aus dem Import
    } else {
      // PRODUKTIVMODUS: use JSON from DOM-Element
      const jsonElement = document.getElementById('jsonDataContainer')
      if (jsonElement) {
        const parsed = JSON.parse(jsonElement.innerHTML)
        leasingData.setData(parsed)
      }
    }
  }

  function initializeLeasingValueSliderFromJson (leasingValueSlider) {
    minValueleasingValueSlider = Number(leasingData.getLabel('value-min')) || FALLBACK_MIN_VALUE
    maxValueleasingValueSlider = Number(leasingData.getLabel('value-max')) || FALLBACK_MAX_VALUE
    // Fill the money input
    const leasingMoneyInputValue = Number(leasingData.getLabel('value-default')) || FALLBACK_MIN_VALUE

    initSlider(
      leasingValueSlider,
      minValueleasingValueSlider,
      maxValueleasingValueSlider,
      leasingMoneyInputValue
    )

    updateLeasingValueSliderLabels()
    updateLeasingMoneyInput(leasingMoneyInputValue)

    // Event listener for manual changes to the input field
    leasingMoneyInput.addEventListener('change', function () {
      const cleanedMoneyValue = leasingMoneyInput.value.match(/\d|[,.]/g)?.join('') || ''
      const inputValue =
        new NumberParser(leasingData.getLocale()).parse(cleanedMoneyValue) || leasingMoneyInput.value // The entered amount of money
      if (!isNaN(inputValue)) {
        // Debounced checkInputValue
        checkInputValue(
          inputValue,
          minValueleasingValueSlider,
          maxValueleasingValueSlider,
          (adjustedValue) => {
            updateLeasingMoneyInput(adjustedValue)
          }
        )

        leasingValueSlider.value = inputValue
        leasingValueSlider.style.backgroundPositionX = calculateBackgroundPositionX(
          leasingValueSlider,
          inputValue,
          minValueleasingValueSlider,
          maxValueleasingValueSlider
        )
        handleInputChange()
      }
    })
  }

  function updateLeasingValueSliderLabels () {
    const selectedLocale = leasingData.getLocale() || FALLBACK_LOCALE
    const selectedCurrency = leasingCurrencyInMoneyInput.innerText || FALLBACK_CURRENCY

    const minFormattedNumber = getCurrencyFormatNumbersOnly(
      selectedLocale,
      selectedCurrency,
      minValueleasingValueSlider
    )

    const maxFormattedNumber = getCurrencyFormatNumbersOnly(
      selectedLocale,
      selectedCurrency,
      maxValueleasingValueSlider
    )

    leasingCalc.querySelector('#moneyMin').textContent = minFormattedNumber
    leasingCalc.querySelector('#moneyMax').textContent = maxFormattedNumber
  }

  function updateLeasingMoneyInput (newValue) {
    const selectedLocale = leasingData.getLocale() || FALLBACK_LOCALE
    const selectedCurrency = leasingCurrencyInMoneyInput.innerText || FALLBACK_CURRENCY

    // Parse the value and ensure it's within the correct format
    leasingMoneyInput.value = getCurrencyFormatNumbersOnly(selectedLocale, selectedCurrency, newValue)
    handleInputChange()
  }

  function checkInputValue (inputValue, minValueleasingValueSlider, maxValueleasingValueSlider, callback) {
    if (inputValue < minValueleasingValueSlider) {
      callback(minValueleasingValueSlider)
    } else if (inputValue > maxValueleasingValueSlider) {
      $('#int-leasing-calc #leasing-advisory').modal('show')
      callback(maxValueleasingValueSlider)
    } else {
      callback(inputValue)
    }
  }

  function populateDropdowns () {
    if (!leasingData.data) return

    const productKeys = leasingData.getProducts()
    productSelect.innerHTML = ''

    const productSelectCol = productSelect.closest('.col-6')
    const assetSelectCol = assetSelect.closest('.col-6')

    if (productKeys.length === 1) {
      const singleProductKey = productKeys[0]
      productSelectCol.style.display = 'none'
      assetSelectCol.classList.remove('col-6')
      assetSelectCol.classList.add('col-12')

      const option = document.createElement('option')
      option.value = singleProductKey
      option.selected = true
      productSelect.appendChild(option)

      populateAssets(singleProductKey)

    } else {
      productSelectCol.style.display = ''
      assetSelectCol.classList.remove('col-12')
      assetSelectCol.classList.add('col-6')

      // placeholder-Init for placeholder-div
      initPlaceholderDropdown(
        productSelect,
        leasingData.getLabel('product-placeholder') // 🔧 NEU
      )

      productKeys.forEach(key => {
        const option = document.createElement('option')
        option.value = key
        option.textContent = key
        productSelect.appendChild(option)
      })

      productSelect.addEventListener('change', () => {
        const selectedProduct = productSelect.value
        populateAssets(selectedProduct)
      })
    }
  }

  function populateAssets (productKey) {
    const assets = leasingData.getAssets(productKey)
    assetSelect.innerHTML = ''

    if (assets.length > 1) {
      // placeholder-Init for placeholder-div
      initPlaceholderDropdown(
        assetSelect,
        leasingData.getLabel('category-placeholder')
      )
    }

    assets.forEach(asset => {
      const option = document.createElement('option')
      option.value = asset.assetName
      option.textContent = asset.assetName
      assetSelect.appendChild(option)
    })

    if (assets.length === 1) {
      const singleAssetName = assets[0].assetName
      assetSelect.value = singleAssetName

      // Runtime-Slider & Dropdown init
      const selectedAsset = leasingData.getAsset(productKey, singleAssetName)
      if (selectedAsset) {
        populateRuntimeSlider()
      }

      handleInputChange()
    }
  }

  function populateRuntimeSliderFromAssetSelection () {
    const selectedProductKey = productSelect.value
    const selectedAssetName = assetSelect.value

    if (!selectedProductKey || !selectedAssetName) return

    const selectedAsset = leasingData.getAsset(productSelect.value, assetSelect.value)

    if (!selectedAsset) return

    populateRuntimeSlider(selectedAsset)
  }

  function populateRuntimeSlider () {
    const productKey = productSelect.value
    const assetName = assetSelect.value

    const months = leasingData.getAvailableMonths(productKey, assetName)
    if (!months.length) return

    const minValue = Math.min(...months)
    const maxValue = Math.max(...months)
    const initialValue = minValue

    initSlider(leasingRuntimeSlider, minValue, maxValue, initialValue)
    setLeasingGoal(leasingCalc, minValue.toString(), maxValue.toString())

    // Slider → Dropdown sync and snap
    leasingRuntimeSlider.addEventListener('input', () => {
      const nearest = findNearestMonth(leasingRuntimeSlider.value, months)

      leasingRuntimeSlider.value = nearest
      leasingRuntimeDropdown.value = nearest

      leasingRuntimeSlider.style.backgroundPositionX = calculateBackgroundPositionX(
        leasingRuntimeSlider,
        nearest,
        leasingRuntimeSlider.min,
        leasingRuntimeSlider.max
      )

      handleInputChange()
    })

    // Fill dropdown
    populateRuntimeDropdown(productKey, assetName)

    // Set initial value in dropdown
    leasingRuntimeDropdown.value = initialValue
  }

  function setLeasingGoal (leasingGoalContainer, min, max) {
    leasingGoalContainer.querySelector('#goalMin').textContent = min
    leasingGoalContainer.querySelector('#goalMax').textContent = max
  }

  function populateRuntimeDropdown (productKey, assetName) {
    leasingRuntimeDropdown.innerHTML = ''

    const monthsAndFactors = leasingData.getMonthsAndFactors(productKey, assetName)

    if (monthsAndFactors) {
      Object.keys(monthsAndFactors).forEach((month) => {
        const option = document.createElement('option')
        option.value = month
        option.text = `${month}`
        leasingRuntimeDropdown.appendChild(option)
      })

      // Dropdown → Slider sync
      leasingRuntimeDropdown.addEventListener('change', function () {
        const selected = Number(leasingRuntimeDropdown.value)
        leasingRuntimeSlider.value = selected

        leasingRuntimeSlider.style.backgroundPositionX = calculateBackgroundPositionX(
          leasingRuntimeSlider,
          selected,
          leasingRuntimeSlider.min,
          leasingRuntimeSlider.max
        )
        handleInputChange()
      })

    } else {
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.text = 'Keine Laufzeit verfügbar'
      defaultOption.disabled = true
      defaultOption.selected = true
      leasingRuntimeDropdown.appendChild(defaultOption)
    }
  }

  function updateForm () {

    const selectedLocale = leasingData.getLocale()

    const setValueIfExists = (selector, value) => {
      const field = leasingCalc.querySelector(selector)
      if (field) field.value = value
    }
    setValueIfExists('#h_value', cleanAndGetFormat(selectedLocale, leasingMoneyInput.value))
    setValueIfExists('#h_runtime', leasingRuntimeDropdown.value)
    setValueIfExists('#h_result', cleanAndGetFormat(selectedLocale, leasingResult.innerText))
    setValueIfExists('#h_result', leasingData.getShowRate() ? cleanAndGetFormat(selectedLocale, leasingResult.innerText) : 'no rate shown')
    setValueIfExists('#h_category', assetSelect.value)
    setValueIfExists('#h_product', productSelect.value)
  }

  function cleanAndGetFormat (locale, input) {
    const cleanedMoneyValue = input.match(/\d|[,.]/g)?.join('') || ''
    return new NumberParser(locale).parse(cleanedMoneyValue) || input
  }
}

export default {
  init,
}
